import React from "react";
import $ from 'jquery';
import _ from 'lodash';

import ProjectScope from "./../../projectScope/projectScope";
import ActionTypes from "./../../../actionTypes";
import * as Misc from "./../../../misc";
import Config from './../../../config';
import OnScreenKeyboard from "../../OnScreenKeyboard/keyboard";
import StonesStore from './../../../stores/stonesStore';
import uuid from "uuid";
import Analytics from './../../../analytics';

import NoteItem from "./noteItem";
import UploadItem from "./uploadItem";

const __pointerPosition = {
  uploads: 46,
  notes: 168
};

let __dragTimer;

export default class NotesUploadView extends React.Component {
  constructor(props) {
    super(props);

    const note = ProjectScope.currentNote();
    this.state = {
      show: this.props.show || 'notes',
      currentItemDescription: note ? note.text : '',
      currentItemChanged: false,
      notes: [{uid: -1, addNew: true}].concat(ProjectScope.notes()),
      documents: [{uid: -1, addNew: true, click: this.handleAddDocumentClick}].concat(ProjectScope.documents()),
      lastNoteUid: '',
      lastDocumentUid: '',
      showDropZone: false,
      fileReadyToUpload: false,
      isBusy: false,
      notesFieldId: uuid.v4()
    };
  }

  componentDidMount() {
    this.setState({show: this.props.show});
    setTimeout(() => {
      this.setPointerPosition(this.props.show);
    }, 250);

    $(document).on(ActionTypes.CURRENT_NOTE_CHANGED, this.handleCurrentNoteChanged);
    $(document).on(ActionTypes.DOCUMENTS_CHANGED, this.handleDocumentsChanged);
    $(document).on('dragover', this.handleDocumentOnDragOver);
    $(document).on('dragleave', this.handleDocumentOnDragLeave);
    $(document).on('drop', this.handleDocumentOnDragDrop);
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.CURRENT_NOTE_CHANGED, this.handleCurrentNoteChanged);
    $(document).off(ActionTypes.DOCUMENTS_CHANGED, this.handleDocumentsChanged);
    $(document).off('dragover', this.handleDocumentOnDragOver);
    $(document).off('dragleave', this.handleDocumentOnDragLeave);
    $(document).off('drop', this.handleDocumentOnDragDrop);
  }

  handleDocumentOnDragOver = (e) => {
    Misc.ignoreDefault(e);

    const dt = e.originalEvent.dataTransfer;
    if (dt.types !== null && (dt.types.indexOf ? dt.types.indexOf('Files') !== -1 : dt.types.contains('application/x-moz-file'))) {
      $("#dropzone").show();
      window.clearTimeout(__dragTimer);
    }
  };

  handleDocumentOnDragLeave = (e) => {
    __dragTimer = window.setTimeout(function () {
      $("#dropzone").hide();
    }, 25);
  };

  handleDocumentOnDragDrop = (e) => {
    Misc.ignoreDefault(e);
    Analytics.sendEvent('drag-drop-file-upload', 'summary-notes');
    __dragTimer = window.setTimeout(() => {
      $("#dropzone").hide();
    }, 25);

    const dataTransfer = e.originalEvent.dataTransfer;
    let files = null;
    if (dataTransfer) {
      files = dataTransfer.files || dataTransfer.items;
    }

    if (!files || !files.length) {
      this.setState({
        show: 'uploads'
      });
      return;
    }

    this.setState({
      fileToUpload: files[0],
      uploadFileName: "<<Upload Folder>>//" + files[0].name,
      fileReadyToUpload: true
    });
  };

  handleCurrentNoteChanged = () => {
    const note = ProjectScope.currentNote();
    this.setState({
      lastNoteUid: note ? note.uid : '',
      currentItemChanged: false,
      currentItemDescription: note ? note.text : '',
      notes: [{uid: -1, addNew: true}].concat(ProjectScope.notes())
    });
  };

  handleDocumentsChanged = () => {
    const document = ProjectScope.currentDocument();
    this.setState({
      lastDocumentUid: document ? document.uid : '',
      currentItemChanged: false,
      currentItemDescription: document ? document.text : '',
      documents: [{uid: -1, addNew: true, click: this.handleAddDocumentClick}].concat(ProjectScope.documents())
    });
  };

  setPointerPosition = (element) => {
    if (document.kvConfig.kioskMode) {
      $(this.refs.docContainerPointer).css('left', __pointerPosition.uploads);
    } else {
      $(this.refs.docContainerPointer).css('left', __pointerPosition[element]);
    }

    if (element === "uploads") {
      if(Config.kioskStandAlone) {
        $("#uploads").css('background-image', "url('../../images/buttons/UploadsSelected.svg')");
        $("#notes").css('background-image', "url('../../images/buttons/Notes.svg')");
      } else {
        $("#uploads").css('background-image', 'url(/content/Views/QuickQuote-v3/images/buttons/UploadsSelected.svg)');
        $("#notes").css('background-image', 'url(/content/Views/QuickQuote-v3/images/buttons/Notes.svg)');
      }
    } else {
      if(Config.kioskStandAlone) {
        $("#uploads").css('background-image', "url('../../images/buttons/Uploads.svg')");
        $("#notes").css('background-image', "url('../../images/buttons/NotesSelected.svg')");
      } else {
        $("#uploads").css('background-image', 'url(/content/Views/QuickQuote-v3/images/buttons/Uploads.svg)');
        $("#notes").css('background-image', 'url(/content/Views/QuickQuote-v3/images/buttons/NotesSelected.svg)');
      }
    }
  };

  handleNotesClick = () => {
    const note = ProjectScope.currentNote();
    this.setState({
      show: 'notes',
      currentItemDescription: note ? note.text : ''
    }, function () {
      this.setPointerPosition('notes');
    });
  };

  handleDocumentsClick = () => {
    const document = ProjectScope.currentDocument();
    this.setState({
      show: 'uploads',
      currentItemDescription: document ? document.text : ''
    }, function () {
      this.setPointerPosition('uploads');
    });
  };

  handleItemDescriptionChanged = (e) => {
    if (!this.state.currentItemChanged) {
      if (this.state.show === 'notes') {
        ProjectScope.markNoteChanged();
      } else if (this.state.show === 'uploads') {
        ProjectScope.markDocumentChanged();
      }
    }

    this.setState({
      currentItemDescription: _.isObject(e) ? e.target.value : e,
      currentItemChanged: true
    });
  };

  handleCloseClick = (e) => {
    Misc.ignoreDefault(e);
    this.props.close();
  };

  handleSaveClick = (e) => {
    Misc.ignoreDefault(e);
    if (this.state.show === 'document-upload-start') {
      this.setState({
        uploadFileName: '',
        fileReadyToUpload: false,
        show: 'uploads'
      });

      ProjectScope.addDocument(this.state.fileToUpload, this.state.currentItemDescription);
      return;
    }

    this.setState({
      currentItemChanged: false
    });
    if (this.state.show === 'notes') {
      ProjectScope.saveNote(this.state.currentItemDescription);
    } else {
      ProjectScope.saveDocument(this.state.currentItemDescription);
    }
  };

  handleCancelClick = (e) => {
    Misc.ignoreDefault(e);

    let show = this.state.show;
    if (this.state.fileReadyToUpload || this.state.show === 'document-upload-start') {
      this.setState({
        fileToUpload: null,
        uploadFileName: '',
        fileReadyToUpload: false,
        show: show = 'uploads'
      });
    }

    const item = show === 'uploads' ? ProjectScope.currentDocument() : ProjectScope.currentNote();
    this.setState({
      currentItemDescription: item ? item.text : '',
      currentItemChanged: false
    });
    if (show === 'notes') {
      ProjectScope.cancelNoteEditing();
    }
    //else if (show === 'uploads') {    }
  };

  handleAddDocumentClick = () => {
    this.setState({
      show: 'document-upload-start',
      currentItemDescription: ''
    });
  };

  handleUploadFileClick = (e) => {
    Misc.ignoreDefault(e);
    $(this.refs.upload_field).click();
  };

  handleUploadFieldChange = (e) => {
    Misc.ignoreDefault(e);
    Analytics.sendClickEvent("summary-notes-upload-file");

    let files = null;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }

    if (!files || !files.length) {
      console.log("No Files selected");
      return;
    }

    this.setState({
      fileToUpload: files[0],
      uploadFileName: "<<Upload Folder>>//" + files[0].name,
      fileReadyToUpload: true
    });
    StonesStore.setUnsavedChanges();
  };

  handleInputFocus = () => {
    Config.isAndroid() && $('.app-container').addClass('app-container--android');
  };

  handleInputBlur = () => {
    $('.app-container').removeClass('app-container--android');
  };

  render() {
    const note = ProjectScope.currentNote();

    let styles = {
      uploads: {
        backgroundImage: 'url(/content/Views/QuickQuote-v3/images/buttons/Uploads.svg)'
      },
      notes: {
        backgroundImage: 'url(/content/Views/QuickQuote-v3/images/buttons/Notes.svg)'
      }
    };

    if(Config.kioskStandAlone) {
      styles.uploads.backgroundImage = "url('../../images/buttons/Uploads.svg')";
      styles.notes.backgroundImage = "url('../../images/buttons/Notes.svg')";
    }

    return (
      <div className="docs-main-panel">
        <div className="docs-close-button" onClick={this.handleCloseClick}/>

        {/*Drop zone for the document upload*/}
        {this.state.show === 'document-upload-start'
          ? (<div className="doc-dropzone-overlay" id="dropzone">
            <div className="doc-dropzone-inlay"/>
          </div>) : null}

        <div className="doc-component-wrapper">
          {document.kvConfig.kioskMode ? null :
            <div id="uploads" onClick={this.handleDocumentsClick} className="doc-button-uploads-documents"
                 style={styles.uploads}/>
          }
          {this.state.show !== 'document-upload-start' ?
            <div id="notes" onClick={this.handleNotesClick} className="doc-button-uploads-documents"
                 style={styles.notes}/>
            : null}

          <div className="doc-container">
            <div className="doc-container-pointer" ref='docContainerPointer'/>

            {this.renderFlexContainer()}

            {this.renderUploadBar()}

            {(this.state.currentItemChanged || (note ? note.isNew : false) || this.state.fileReadyToUpload
            || this.state.show === 'document-upload-start')
              ? (<div className="doc-save-bar">
                <div className="doc-select-uploads-button">
                  {(this.state.show !== 'document-upload-start' || this.state.fileReadyToUpload)
                    ? <div className="doc-select-button doc-save-button" onClick={this.handleSaveClick}>
                      Save</div>
                    : null}
                  <div className="doc-select-button doc-save-button" onClick={this.handleCancelClick}>
                    Cancel
                  </div>
                </div>
              </div>)
              : null}

          </div>
        </div>
      </div>
    );
  }

  renderUploadBar = () => {
    if (this.state.show !== 'document-upload-start') {
      return null;
    }

    return (
      <div className="doc-upload-bar">
        <div className="doc-upload-bar-left">
          <input type="file" name="file" id="file" className="doc-input-box" ref="upload_field"
                 onChange={this.handleUploadFieldChange}/>
          <label id="FileButton" htmlFor="file" onClick={this.handleUploadFileClick}>Choose a file</label>
        </div>
        <div className="doc-upload-bar-right">
          <div id="UploadDisplay" className="doc-input-display">{this.state.uploadFileName}</div>
        </div>
      </div>
    );
  };

  renderFlexContainer = () => {
    switch (this.state.show.toLowerCase()) {
      case "document-upload-start":
        return this.renderDocumentUploadContainer();
      default:
        return this.renderItemsContainer();
    }
  };

  renderDocumentUploadContainer = () => {
    return (
      <div className="doc-flex-container">
        <div className="doc-upload-container-left">
          <div className="doc-upload-area-dotted">
            <div className="doc-upload-area-filled" onClick={this.handleUploadFileClick}/>
          </div>
        </div>
        <div className="doc-upload-container-right">
          <textarea className="doc-notes-textbox" onChange={this.handleItemDescriptionChanged}
                    onFocus={this.handleInputFocus} onBlur={this.handleInputBlur}
                    value={this.state.currentItemDescription} id={this.state.notesFieldId}>
                </textarea>
          <OnScreenKeyboard inputId={this.state.notesFieldId} setValue={this.handleItemDescriptionChanged}
                            top="100px" left="25px"/>
        </div>
      </div>);
  };

  renderItemsContainer = () => {
    return (
      <div className="doc-flex-container">
        <div className="doc-notes-container-left">
          {this.renderItems()}
        </div>
        <div className="doc-notes-container-right">
                <textarea className="doc-notes-textbox" onChange={this.handleItemDescriptionChanged}
                          onFocus={this.handleInputFocus} onBlur={this.handleInputBlur}
                          value={this.state.currentItemDescription} id={this.state.notesFieldId}>
                </textarea>
          <OnScreenKeyboard inputId={this.state.notesFieldId} setValue={this.handleItemDescriptionChanged}
                            top="100px" left="25px"/>
        </div>
      </div>);
  };

  renderItems = () => {
    if (this.state.show === 'notes') {
      return this.state.notes.map(function (note) {
        return <NoteItem note={note} key={note.uid}/>;
      });
    }

    return this.state.documents.map(function (document) {
      return <UploadItem document={document} key={document.uid}/>;
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/common/notesUpload/notesUploadView.js